import { fetchProductImage } from '../utils/productStorefront';

export async function enrichOrderItem(row) {
  const productId = Number(row?.ProductId ?? row?.productId ?? 0);
  let imageSrc = '';

  if (productId) {
    try {
      imageSrc = (await fetchProductImage(productId)) || '';
    } catch {
      imageSrc = '';
    }
  }

  return {
    orderItemId: row?.OrderItemId ?? row?.orderItemId,
    productId,
    productName: row?.ProductName ?? row?.productName ?? 'Product',
    sku: row?.SKU ?? row?.sku ?? '',
    quantity: row?.Quantity ?? row?.quantity ?? 0,
    unitPrice: row?.UnitPrice ?? row?.unitPrice ?? 0,
    totalPrice: row?.TotalPrice ?? row?.totalPrice ?? 0,
    imageSrc,
  };
}

export async function enrichOrderItems(items = []) {
  return Promise.all(items.map(enrichOrderItem));
}
